import {ReactElement, useEffect, useState} from 'react';
import Icon from '../../atoms/Icon/Icon';
import StyledAccordion, {
  StyledAccordionBody,
  StyledAccordionHeader,
  StyledAccordionSubtitle,
  StyledAccordionTitle,
} from './styles';
import Props from './typings';

const Accordion = ({
  title,
  subtitle,
  defaultCollapsed = true,
  hasDividers = false,
  collapsible = true,
  strongTitle = false,
  className,
  children,
  forceOpen,
  onToggle,
}: Props): ReactElement => {
  const [open, setOpen] = useState(forceOpen ?? !defaultCollapsed);

  const onClick = () => {
    if (!collapsible) return;

    const newState = !open;

    setOpen(newState);
    if (onToggle) onToggle(newState);
  };

  useEffect(() => {
    if (forceOpen !== undefined && forceOpen !== open) setOpen(forceOpen);
  }, [forceOpen]);

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault(); // Prevent scrolling on space
      onClick();
    }
  };

  return (
    <StyledAccordion $hasDividers={hasDividers} className={className}>
      <StyledAccordionHeader
        onClick={onClick}
        onKeyDown={onKeyDown}
        $collapsible={collapsible}
        aria-expanded={open}
        tabIndex={0}
      >
        {typeof title === 'string' ? (
          <StyledAccordionTitle $strongTitle={strongTitle}>{title}</StyledAccordionTitle>
        ) : (
          title
        )}

        {subtitle && <StyledAccordionSubtitle>{subtitle}</StyledAccordionSubtitle>}

        {collapsible && <Icon type={open === true ? 'minus' : 'plus'} />}
      </StyledAccordionHeader>

      <StyledAccordionBody $open={open}>{children}</StyledAccordionBody>
    </StyledAccordion>
  );
};

export default Accordion;
